export default __webpack_public_path__ + "static/media/star water1.6 ratio.51dc5287.png";